{
  "nameRequired": "Give your shop a name.",
  "titleAnother": "Create another shop",
  "welcome": "Welcome",
  "welcomeName": "Welcome, {{name}}",
  "lede": "Name your shop as it should appear on AS9102 Form 1. You can change it later.",
  "docTitle": "Set up your shop",
  "cancel": "Cancel",
  "signOut": "Sign out",
  "shopName": "Shop name",
  "shopPlaceholder": "Acme Precision Machining",
  "createShop": "Create shop",
  "startTrial": "Start my 14-day trial",
  "joining": "Joining a teammate's shop? Open the invite link from your email instead."
}
